import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import VanillaTilt from "vanilla-tilt";
import "../styles/portfolioPage.css";

gsap.registerPlugin(ScrollTrigger);

export default function PortfolioPage() {
  const { username } = useParams();
  const [data, setData] = useState(null);
  const projRef = useRef(null);

  useEffect(() => {
    getDoc(doc(db, "NewPortfolios", username))
      .then(snap => {
        if (!snap.exists()) throw new Error("User not found");
        setData(snap.data());
      })
      .catch(err => console.error(err));
  }, [username]);

  useEffect(() => {
    if (!data) return;

    // Fade‑in on scroll for each section
    gsap.utils.toArray(".reveal").forEach((el) => {
      gsap.fromTo(el,
        { autoAlpha: 0, y: 50 },
        {
          duration: 1,
          autoAlpha: 1,
          y: 0,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
          }
        }
      );
    });

    // VanillaTilt on project cards
    if (projRef.current) {
      VanillaTilt.init(
        projRef.current.querySelectorAll(".project-card"),
        { max: 15, speed: 400, glare: true, "max-glare": 0.3 }
      );
    }
  }, [data]);

  if (!data) return <div className="loading-message">Loading…</div>;

  return (
    <div className="portfolio-container">
      <div className="profile-header reveal">
        <div className="profile-overlay">
          <h1>{data.name}</h1>
          <p>{data.tagline || data.bio}</p>
        </div>
      </div>

      <section className="about-section reveal" id="about">
        <div className="about-image">
          <img src={data.photoURL || "/images/default-avatar.jpg"} alt="About" />
        </div>
        <div className="about-text">
          <h2>About Me</h2>
          <p>{data.aboutLong || data.bio}</p>
        </div>
      </section>

      {data.skills?.length > 0 && (
        <section className="skills-section reveal" id="skills">
          <h2>My Skills</h2>
          {data.skills.map(({ name, level }) => (
            <div
              key={name}
              className="skill-bar"
              style={{ "--level": `${level}%` }}
            >
              <div className="label">
                <span>{name}</span>
                <span>{level}%</span>
              </div>
              <div className="progress"></div>
            </div>
          ))}
        </section>
      )}

      {data.projects?.length > 0 && (
        <section
          className="projects-section reveal"
          id="projects"
          ref={projRef}
        >
          <h2>Featured Projects</h2>
          <div className="projects-grid">
            {data.projects.map((p) => (
              <div key={p.id} className="project-card">
                <img src={p.imageURL} alt={p.title} />
                <div className="project-overlay">
                  <h3>{p.title}</h3>
                  <p>{p.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      <section className="contact-section reveal" id="contact">
        <h2>Work With Me</h2>
        <p>{data.callToAction || "Let's create something amazing together."}</p>
        <a href={`mailto:${data.email}`} className="button">
          Get in Touch
        </a>
      </section>
    </div>
  );
}
